import _regeneratorRuntime from "@babel/runtime/regenerator";

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

import DebugLogger from "debug";
import { multicast, Observable, Subject } from "observable-fns";
import { allSettled } from "../ponyfills";
import { defaultPoolSize } from "./implementation";
import { PoolEventType } from "./pool-types";
import { Thread } from "./thread";
export { PoolEventType, Thread };
var nextPoolID = 1;

function createArray(size) {
  var array = [];

  for (var index = 0; index < size; index++) {
    array.push(index);
  }

  return array;
}

function delay(ms) {
  return new Promise(function (resolve) {
    return setTimeout(resolve, ms);
  });
}

function flatMap(array, mapper) {
  return array.reduce(function (flattened, element) {
    return [].concat(_toConsumableArray(flattened), _toConsumableArray(mapper(element)));
  }, []);
}

function slugify(text) {
  return text.replace(/\W/g, " ").trim().replace(/\s+/g, "-");
}

function spawnWorkers(spawnWorker, count) {
  return createArray(count).map(function () {
    return {
      init: spawnWorker(),
      runningTasks: []
    };
  });
}

var WorkerPool = /*#__PURE__*/function () {
  function WorkerPool(spawnWorker, optionsOrSize) {
    var _this = this;

    _classCallCheck(this, WorkerPool);

    this.eventSubject = new Subject();
    this.initErrors = [];
    this.isClosing = false;
    this.nextTaskID = 1;
    this.taskQueue = [];
    var options = typeof optionsOrSize === "number" ? {
      size: optionsOrSize
    } : optionsOrSize || {};
    var _options$size = options.size,
        size = _options$size === void 0 ? defaultPoolSize : _options$size;
    this.debug = DebugLogger("threads:pool:".concat(slugify(options.name || String(nextPoolID++))));
    this.options = options;
    this.workers = spawnWorkers(spawnWorker, size);
    this.eventObservable = multicast(Observable.from(this.eventSubject));
    Promise.all(this.workers.map(function (worker) {
      return worker.init;
    })).then(function () {
      return _this.eventSubject.next({
        type: PoolEventType.initialized,
        size: _this.workers.length
      });
    }, function (error) {
      _this.debug("Error while initializing pool worker:", error);

      _this.eventSubject.error(error);

      _this.initErrors.push(error);
    });
  }

  _createClass(WorkerPool, [{
    key: "findIdlingWorker",
    value: function findIdlingWorker() {
      var _this$options$concurr = this.options.concurrency,
          concurrency = _this$options$concurr === void 0 ? 1 : _this$options$concurr;
      return this.workers.find(function (worker) {
        return worker.runningTasks.length < concurrency;
      });
    }
  }, {
    key: "runPoolTask",
    value: function runPoolTask(worker, task) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var workerID, returnValue;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                workerID = this.workers.indexOf(worker) + 1;
                this.debug("Running task #".concat(task.id, " on worker #").concat(workerID, "..."));
                this.eventSubject.next({
                  type: PoolEventType.taskStart,
                  taskID: task.id,
                  workerID: workerID
                });
                _context.prev = 3;
                _context.t0 = task;
                _context.next = 7;
                return worker.init;

              case 7:
                _context.t1 = _context.sent;
                _context.next = 10;
                return _context.t0.run.call(_context.t0, _context.t1);

              case 10:
                returnValue = _context.sent;
                this.debug("Task #".concat(task.id, " completed successfully"));
                this.eventSubject.next({
                  type: PoolEventType.taskCompleted,
                  returnValue: returnValue,
                  taskID: task.id,
                  workerID: workerID
                });
                _context.next = 19;
                break;

              case 15:
                _context.prev = 15;
                _context.t2 = _context["catch"](3);
                this.debug("Task #".concat(task.id, " failed"));
                this.eventSubject.next({
                  type: PoolEventType.taskFailed,
                  taskID: task.id,
                  error: _context.t2,
                  workerID: workerID
                });

              case 19:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this, [[3, 15]]);
      }));
    }
  }, {
    key: "run",
    value: function run(worker, task) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
        var _this2 = this;

        var runPromise;
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                runPromise = function () {
                  return __awaiter(_this2, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
                    var removeTaskFromWorkersRunningTasks;
                    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
                      while (1) {
                        switch (_context2.prev = _context2.next) {
                          case 0:
                            removeTaskFromWorkersRunningTasks = function removeTaskFromWorkersRunningTasks() {
                              worker.runningTasks = worker.runningTasks.filter(function (someRunPromise) {
                                return someRunPromise !== runPromise;
                              });
                            }; // Defer task execution by one tick to give handlers time to subscribe


                            _context2.next = 3;
                            return delay(0);

                          case 3:
                            _context2.prev = 3;
                            _context2.next = 6;
                            return this.runPoolTask(worker, task);

                          case 6:
                            _context2.prev = 6;
                            removeTaskFromWorkersRunningTasks();

                            if (!this.isClosing) {
                              this.scheduleWork();
                            }

                            return _context2.finish(6);

                          case 10:
                          case "end":
                            return _context2.stop();
                        }
                      }
                    }, _callee2, this, [[3,, 6, 10]]);
                  }));
                }();

                worker.runningTasks.push(runPromise);

              case 2:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }));
    }
  }, {
    key: "scheduleWork",
    value: function scheduleWork() {
      this.debug("Attempt de-queueing a task in order to run it...");
      var availableWorker = this.findIdlingWorker();
      if (!availableWorker) return;
      var nextTask = this.taskQueue.shift();

      if (!nextTask) {
        this.debug("Task queue is empty");
        this.eventSubject.next({
          type: PoolEventType.taskQueueDrained
        });
        return;
      }

      this.run(availableWorker, nextTask);
    }
  }, {
    key: "taskCompletion",
    value: function taskCompletion(taskID) {
      var _this3 = this;

      return new Promise(function (resolve, reject) {
        var eventSubscription = _this3.events().subscribe(function (event) {
          if (event.type === PoolEventType.taskCompleted && event.taskID === taskID) {
            eventSubscription.unsubscribe();
            resolve(event.returnValue);
          } else if (event.type === PoolEventType.taskFailed && event.taskID === taskID) {
            eventSubscription.unsubscribe();
            reject(event.error);
          } else if (event.type === PoolEventType.terminated) {
            eventSubscription.unsubscribe();
            reject(Error("Pool has been terminated before task was run."));
          }
        });
      });
    }
  }, {
    key: "settled",
    value: function settled() {
      var allowResolvingImmediately = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee4() {
        var _this4 = this;

        var getCurrentlyRunningTasks, taskFailures, failureSubscription;
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                getCurrentlyRunningTasks = function getCurrentlyRunningTasks() {
                  return flatMap(_this4.workers, function (worker) {
                    return worker.runningTasks;
                  });
                };

                taskFailures = [];
                failureSubscription = this.eventObservable.subscribe(function (event) {
                  if (event.type === PoolEventType.taskFailed) {
                    taskFailures.push(event.error);
                  }
                });

                if (!(this.initErrors.length > 0)) {
                  _context4.next = 5;
                  break;
                }

                return _context4.abrupt("return", Promise.reject(this.initErrors[0]));

              case 5:
                if (!(allowResolvingImmediately && this.taskQueue.length === 0)) {
                  _context4.next = 9;
                  break;
                }

                _context4.next = 8;
                return allSettled(getCurrentlyRunningTasks());

              case 8:
                return _context4.abrupt("return", taskFailures);

              case 9:
                _context4.next = 11;
                return new Promise(function (resolve, reject) {
                  var subscription = _this4.eventObservable.subscribe({
                    next: function next(event) {
                      if (event.type === PoolEventType.taskQueueDrained) {
                        subscription.unsubscribe();
                        resolve(void 0);
                      }
                    },
                    error: reject // make a pool-wide error reject the completed() result promise

                  });
                });

              case 11:
                _context4.next = 13;
                return allSettled(getCurrentlyRunningTasks());

              case 13:
                failureSubscription.unsubscribe();
                return _context4.abrupt("return", taskFailures);

              case 15:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));
    }
  }, {
    key: "completed",
    value: function completed() {
      var allowResolvingImmediately = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee5() {
        var _this5 = this;

        var settlementPromise, earlyExitPromise, errors;
        return _regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                settlementPromise = this.settled(allowResolvingImmediately);
                earlyExitPromise = new Promise(function (resolve, reject) {
                  var subscription = _this5.eventObservable.subscribe({
                    next: function next(event) {
                      if (event.type === PoolEventType.taskQueueDrained) {
                        subscription.unsubscribe();
                        resolve(settlementPromise);
                      } else if (event.type === PoolEventType.taskFailed) {
                        subscription.unsubscribe();
                        reject(event.error);
                      }
                    },
                    error: reject // make a pool-wide error reject the completed() result promise

                  });
                });
                _context5.next = 4;
                return Promise.race([settlementPromise, earlyExitPromise]);

              case 4:
                errors = _context5.sent;

                if (!(errors.length > 0)) {
                  _context5.next = 7;
                  break;
                }

                throw errors[0];

              case 7:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, this);
      }));
    }
  }, {
    key: "events",
    value: function events() {
      return this.eventObservable;
    }
  }, {
    key: "queue",
    value: function queue(taskFunction) {
      var _this6 = this;

      var _this$options$maxQueu = this.options.maxQueuedJobs,
          maxQueuedJobs = _this$options$maxQueu === void 0 ? Infinity : _this$options$maxQueu;

      if (this.isClosing) {
        throw Error("Cannot schedule pool tasks after terminate() has been called.");
      }

      if (this.initErrors.length > 0) {
        throw this.initErrors[0];
      }

      var taskID = this.nextTaskID++;
      var taskCompletion = this.taskCompletion(taskID);
      taskCompletion.catch(function (error) {
        // Prevent unhandled rejections here as we assume the user will use
        // `pool.completed()`, `pool.settled()` or `task.catch()` to handle errors
        _this6.debug("Task #".concat(taskID, " errored:"), error);
      });
      var task = {
        id: taskID,
        run: taskFunction,
        cancel: function cancel() {
          if (_this6.taskQueue.indexOf(task) === -1) return;
          _this6.taskQueue = _this6.taskQueue.filter(function (someTask) {
            return someTask !== task;
          });

          _this6.eventSubject.next({
            type: PoolEventType.taskCanceled,
            taskID: task.id
          });
        },
        then: taskCompletion.then.bind(taskCompletion)
      };

      if (this.taskQueue.length >= maxQueuedJobs) {
        throw Error("Maximum number of pool tasks queued. Refusing to queue another one.\n" + "This usually happens for one of two reasons: We are either at peak " + "workload right now or some tasks just won't finish, thus blocking the pool.");
      }

      this.debug("Queueing task #".concat(task.id, "..."));
      this.taskQueue.push(task);
      this.eventSubject.next({
        type: PoolEventType.taskQueued,
        taskID: task.id
      });
      this.scheduleWork();
      return task;
    }
  }, {
    key: "terminate",
    value: function terminate(force) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee7() {
        var _this7 = this;

        return _regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                this.isClosing = true;

                if (force) {
                  _context7.next = 4;
                  break;
                }

                _context7.next = 4;
                return this.completed(true);

              case 4:
                this.eventSubject.next({
                  type: PoolEventType.terminated,
                  remainingQueue: _toConsumableArray(this.taskQueue)
                });
                this.eventSubject.complete();
                _context7.next = 8;
                return Promise.all(this.workers.map(function (worker) {
                  return __awaiter(_this7, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee6() {
                    return _regeneratorRuntime.wrap(function _callee6$(_context6) {
                      while (1) {
                        switch (_context6.prev = _context6.next) {
                          case 0:
                            _context6.t0 = Thread;
                            _context6.next = 3;
                            return worker.init;

                          case 3:
                            _context6.t1 = _context6.sent;
                            return _context6.abrupt("return", _context6.t0.terminate.call(_context6.t0, _context6.t1));

                          case 5:
                          case "end":
                            return _context6.stop();
                        }
                      }
                    }, _callee6);
                  }));
                }));

              case 8:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7, this);
      }));
    }
  }]);

  return WorkerPool;
}();

WorkerPool.EventType = PoolEventType;
/**
 * Thread pool constructor. Creates a new pool and spawns its worker threads.
 */

function PoolConstructor(spawnWorker, optionsOrSize) {
  // The function exists only so we don't need to use `new` to create a pool (we still can, though).
  // If the Pool is a class or not is an implementation detail that should not concern the user.
  return new WorkerPool(spawnWorker, optionsOrSize);
}

PoolConstructor.EventType = PoolEventType;
/**
 * Thread pool constructor. Creates a new pool and spawns its worker threads.
 */

export var Pool = PoolConstructor;